const fieldsErrors = {
  required: 'Required',
  max: (value) => `Max: ${value}`,
  min: (value) => `Min: ${value}`,
  withoutAt: 'The @ symbol is already given',
};

export default fieldsErrors;
